import { BrowserRouter, Routes, Route } from "react-router";
import Auth from "./pages/Auth";
import { Layout } from "./components/Layout";
import Home from "./pages/Home";
import ConversationPage from "./pages/Conversation";

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/auth" element={<Auth />} />
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/c/:conversationId" element={<ConversationPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
